// Imports Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/** @namespace IngresoComponent */
import { IngresoComponent } from './components/ingreso/ingreso.component';

/**
 * Routes associated to components
 * @constant
 * @type {Array<JSON>}
 */
const routes: Routes = [
    { path: '', component: IngresoComponent },
    { path: 'ingreso', component: IngresoComponent }
];

/** @module NgModule main app */
@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ],
    providers: []
})

/**
* Module main app routing
* @class
*/
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/GIT/F260V3/ingreso/ng_ingresosimple260/Simple260Ingreso/src/app/app-routing.module.ts